import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useState, useRef, useEffect } from 'react';
import { useClickOutsideElement } from '../hooks/useClickOutsideElement.js';

var useTrackPopOver = function useTrackPopOver() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    infoTextVisible = _useState2[0],
    setInfoTextVisible = _useState2[1];
  var timeoutRef = useRef(null);
  var popOver = useRef(null);
  var onClickInfo = function onClickInfo() {
    setInfoTextVisible(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(function () {
      setInfoTextVisible(false);
    }, 10000);
  };
  var closePreview = function closePreview() {
    setInfoTextVisible(false);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = null;
  };
  useClickOutsideElement(popOver, closePreview);
  useEffect(function () {
    return function () {
      return clearTimeout(timeoutRef.current);
    };
  }, []);
  return {
    infoTextVisible: infoTextVisible,
    onClickInfo: onClickInfo,
    popOver: popOver
  };
};

export { useTrackPopOver };
